export default {
  options: [
    {
      name: "Home",
      slug: "",
      image: "home.jpg",
      borderColor: "lightgray",
      quote: "Hi my name is Dylan and I like to build things",
      author: "Welcome to my Portfolio",
      title: {
        left: "7vw",
        top: "32vh",
        fontSize: "90px",
        name: "Home",
        color: "white"
      }
    },
    {
      name: "Work",
      slug: "work",
      image: "work.jpeg",
      borderColor: "#E1D0C0",
      quote: "Opportunity is missed by most people because it is dressed in overalls and looks like work.",
      author: "Thomas Edison",
      title: {
        left: "10vw",
        top: "45vh",
        fontSize: "12vw",
        name: "Work",
        color: "white"
      }
    },
    {
      name: "Projects",
      slug: "projects",
      image: "projects.jpg",
      borderColor: "rgb(179, 108, 94)",
      quote: "The secret to getting ahead is getting started",
      author: "Mark Twain",
      title: {
        left: "5%",
        top: "43%",
        fontSize: "12vw",
        name: "Projects",
        color: "#EAEAEA"
      }
    },
    {
      name: "School",
      slug: "school",
      image: "school.jpeg",
      borderColor: "rgb(0, 255, 196)",
      quote: "Sometimes you never realize the value of a moment until it becomes a memory",
      author: "Dr. Suess",
      title: {
        left: "40%",
        top: "35%",
        fontSize: "12vw",
        name: "School",
        color: "white"
      }
    },
    {
      name: "Blog",
      slug: "blog",
      image: "blog.jpg",
      borderColor: "#2C365D",
      quote: "Sometimes you never realize the value of a moment until it becomes a memory",
      author: "Dr. Suess",
      title: {
        left: "50vw",
        top: "35vh",
        fontSize: "12vw",
        name: "Blog",
        color: "#565656"
      }
    }
  ]
};
